import React from 'react';
import {Paper, Typography} from "@mui/material";


import ProcurementContainer from '../containers/ProcurementContainer';

import RequisitionsList from '../lists/RequisitionsList';

const RequisitionPage: React.FC = () => {
  return (
    <ProcurementContainer>
      <Typography
        variant='h1'
        gutterBottom
        sx={{
          fontWeight: 'bold',
          color: '#123456',
          fontSize: { xs: '1.8rem', sm: '2.5rem' },
          wordBreak: 'break-word',
        }}
      >
       Requisitions
      </Typography>

      <Paper sx={{ my: { xs: 2, sm: 5 }, p: { xs: 1, sm: 2 } }}>
        <RequisitionsList/>
      </Paper>
    </ProcurementContainer>

  )
}

export default RequisitionPage;